import { render } from "./EditCates.vue?vue&type=template&id=0073ce82&scoped=true"
import script from "./EditCates.vue?vue&type=script&lang=js"
export * from "./EditCates.vue?vue&type=script&lang=js"

import "./EditCates.vue?vue&type=style&index=0&id=0073ce82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0073ce82"]])

export default __exports__